import { useTranslations } from 'next-intl';
import { SavedList } from 'services/savedLists/types';
import styles from '../../saved-list-drawer.module.scss';
import cx from 'classnames';
import SavedListTableTypeCell from './saved-list-table-type-cell/saved-list-table-type-cell';
import { CatRadioField, CatIconStarFilled } from 'components/blocks-components';
import { CellContext } from '@tanstack/react-table';
import SavedListTableLinkCell from './saved-list-table-link-cell';

const SavedListTableMobileCell = ({
  info,
  isCspUser,
  savedListDetailFeatureFlag
}: {
  isCspUser: boolean;
  info: CellContext<SavedList, unknown>;
  savedListDetailFeatureFlag?: boolean;
}) => {
  const t = useTranslations();

  return (
    <div className="d-flex justify-content-between p-3">
      <div className="d-flex">
        <div className={styles['saved-list-drawer__body-mobile--radio-button']}>
          <CatRadioField
            value={info.row.original.shoppingListId.toString()}
            name="radio-saved-list"
            hideLabel
            checked={info.row.getIsSelected()}
            onBlRadioChange={info.row.getToggleSelectedHandler()}
          />
        </div>
        <div className="d-flex flex-column">
          <p
            className={cx(
              'mb-0 ps-2 cat-u-theme-typography-body-sm text-break',
              styles['saved-list-drawer__body-mobile--name']
            )}
          >
            {info.row.original.name}
          </p>

          <p className="mb-0 ps-2 pb-1 cat-u-theme-typography-footnote">
            {`${t('MO_LAST_UPDATED')} : ${info.row.original.createdOrLastUpdatedDate.formattedDate}`}
          </p>
          {isCspUser ? (
            <>
              <p className="mb-0 ps-2 pb-1 cat-u-theme-typography-footnote">
                {info.row.original.createdBy}
              </p>
              <div className="d-flex align-items-end ps-2">
                <SavedListTableTypeCell type={info.row.original.type} />
                <span className="px-1">|</span>
                <p className="mb-0 cat-u-theme-typography-footnote">
                  {t('MSC_ITEMS', {
                    '0': info.row.original.orderItemsQuantity
                  })}
                </p>
              </div>
            </>
          ) : (
            <p className="mb-0 ps-2 cat-u-theme-typography-footnote">
              {t('MSC_ITEMS', {
                '0': info.row.original.orderItemsQuantity
              })}
            </p>
          )}
        </div>
      </div>

      <div className="d-flex align-items-start">
        {info.row.original.isFavorite && (
          <CatIconStarFilled
            color="knockout-brand"
            data-testid="cat-icon-star"
            className="p-2"
          />
        )}
        <SavedListTableLinkCell
          isMobile
          info={info}
          savedListDetailFeatureFlag={savedListDetailFeatureFlag}
        />
      </div>
    </div>
  );
};

export default SavedListTableMobileCell;
